import { ProtocolSettings, PrtgSettings } from 'DiscoveryEngine.TS/Protocols';
import { MonitorSettings, MonitorSettingsBase, MonitorSettingsEntry } from './MonitorSettings';
import { MonitorType } from 'DiscoveryEngine.TS/Core';


export class MonitorSettings_PrtgEntry extends MonitorSettingsEntry {

	public get DisplayName(): string {
		return "MonitorSettings_PrtgEntry";
	}
}


export class MonitorSettings_PRTG extends MonitorSettings<MonitorSettings_PrtgEntry> {

	public PrtgTargetGUID: string;

	constructor() {
		super();
		this.MonitorType = MonitorType.PRTG;
		this.PrtgTargetGUID = "";
	}

	public get HasPrtgTargetGUID(): boolean {
		return !!this.PrtgTargetGUID;
	}

	public CopySettings(other: MonitorSettingsBase): void {
		if (!other)
			return;

		if (other == this)
			return;

		let otherSettings = other as MonitorSettings_PRTG;
		if (!otherSettings)
			return;

		super.CopySettings(other);

		this.PrtgTargetGUID = otherSettings.PrtgTargetGUID;
	}

	public SetTarget(protoSettings: ProtocolSettings): void {
		let prtgSettings = (protoSettings as PrtgSettings);
		if (prtgSettings) {
			this.PrtgTargetGUID = prtgSettings.GUID;
		}
	}

	protected CreateEntry(): MonitorSettings_PrtgEntry {
		return new MonitorSettings_PrtgEntry();
	}

	public Find(other: MonitorSettings_PrtgEntry): MonitorSettings_PrtgEntry {
		return null;
	}

	protected get ObjSerEntriesName(): string {
		return "monitored_prtg_sensors";
	}

	public Write(obj: any, context: any): void {
		obj.monitor_settings = {};
		obj = obj.monitor_settings;

		super.Write(obj, context);

		if (this.HasPrtgTargetGUID)
			obj.prtg_proto_guid = this.PrtgTargetGUID;
	}

	public Read(obj: any, context: any): void {
		if (!obj.monitor_settings)
			throw new Error();
		obj = obj.monitor_settings;

		super.Read(obj, context);

		if (obj.prtg_proto_guid !== undefined)
			this.PrtgTargetGUID = obj.prtg_proto_guid;
	}
}
